<!--
INTELLECTUAL PROPERTY NOTICE
© Orbit Tickets Ltd. All rights reserved.
This file contains Custom / Included Intellectual Property created for and owned by the Customer as part of an application developed by Kaleida within the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, the inclusion of any application within the Platform does not restrict the Customer's right to use Custom / Included Intellectual Property outside of the Platform.
-->
<!-- IP-NOTICE: CUSTOM -->
<div [formGroup]="dataForm" class="form-background">
	<div class="header-mat-card-padding">
		<mat-card class="header-width-pixels form-card">
			<mat-card-content>
				<div class="flex-layout-row flex-layout-align-space-between-center">
					<div class="flex-layout-row flex-layout-gap-20px name-input">
						<mat-form-field class="flex-layout-align-center">
							<mat-label>Name</mat-label>
							<input formControlName="name" matInput tabIndex="1" />
							<mat-error *ngIf="name.touched && name.errors?.required"> Name is required </mat-error>
							<mat-error *ngIf="name.touched && name.errors?.maxlength"> Name must be no more than 200 characters </mat-error>
						</mat-form-field>
					</div>
					<div class="flex-layout-gap-10px button-bottom-padding">
						<button mat-raised-button (click)="save()" color="primary" tabIndex="13">{{ saveText }}</button>
						<button mat-raised-button (click)="cancel()" tabIndex="14">Cancel</button>
					</div>
				</div>
				<concurrency-error [message]="concurrencyErrorMessage" (reloadRequested)="loadFormDetails()"></concurrency-error>
			</mat-card-content>
		</mat-card>
	</div>

	<div class="flex-layout-row">
		<div class="form-width-pixels form-mat-card-padding">
			<mat-card class="main-card">
				<mat-card-content>
					<div>
						<e-ticket-layout-picker [startTabIndex]="2" formControlName="layoutStyle" [layoutStyleLookupData]="layoutStyleLookupData"></e-ticket-layout-picker>

						<div *ngIf="showETicketText">
							<mat-label class="display-label">eTicket Text</mat-label>
							<!-- tab index is set in the ngOnInit -->
							<editor formControlName="content" apiKey="{{ tinyMceApiKey }}" [init]="tinyMceSettings" (onInit)="mceOnInit()"></editor>
							<pseudo-form-field-error [errorMessage]="'eTicket Text is required'" [showError]="content.touched && content.errors?.required"> </pseudo-form-field-error>
						</div>

						<div *ngIf="showFadeImage" class="pseudo-form-field flex-layout-column">
							<mat-label class="display-label">Fade Image Towards Text</mat-label>
							<boolean-radio-group formControlName="fadeImageTowardsText" [startTabIndex]="7"></boolean-radio-group>
						</div>

						<div>
							<mat-label class="display-label">Background Option</mat-label>
							<mat-radio-group formControlName="backgroundOption">
								<div class="flex-layout-column flex-layout-gap-0px flex-align-start">
									<mat-radio-button *ngFor="let lookup of backgroundOptionLookupData" [value]="lookup.id" [tabIndex]="lookup.id + 8">
										{{ lookup.text }}
									</mat-radio-button>
								</div>
							</mat-radio-group>
						</div>

						<div *ngIf="imageIsVisible" class="flex-layout-column">
							<mat-label class="display-label">eTicket Image</mat-label>
							<image-selector formControlName="image" accept="image/png, image/jpeg" (isValid)="setImageIsValid($event)" (invalidErrorType)="setImageValidationMessage($event)" [startTabIndex]="11"></image-selector>
							<span *ngIf="layoutStyleIsEitherImageWithTextOption">Note: the uploaded image should be 712 pixels x 570 pixels</span>
							<span *ngIf="layoutStyleIsFullWidthImage">Note: the uploaded image should be 1424 pixels x 570 pixels</span>
							<pseudo-form-field-error [errorMessage]="imageErrorMessage()" [showError]="showImageError()"> </pseudo-form-field-error>
						</div>
					</div>
				</mat-card-content>
			</mat-card>
		</div>

		<div class="preview-width-pixels">
			<mat-card class="main-card">
				<mat-card-content>
					<e-ticket-design-preview-view
						[designId]="data.itemId"
						[eventId]="data.eventId"
						[currentLayoutStyle]="dataForm.get('layoutStyle').value"
						[currentText]="dataForm.get('content').value"
						[currentImage]="dataForm.get('image').value"
						[fadeImage]="dataForm.get('fadeImageTowardsText').value"
						[backgroundOption]="dataForm.get('backgroundOption').value"></e-ticket-design-preview-view>
				</mat-card-content>
			</mat-card>
		</div>
	</div>
</div>
